export const defaultInitialValues = {
  name: '',
  lastName: '',
  email: '',
  comment: '',
  duration: '',
  date: '',
}
